import { InfluxQueryOutline, MetricsData } from '@app/driver-metrics/model/driver-metrics.interface';
import { DriverStaticData, DriverStaticPayload } from '@app/driver-metrics/model/driver-static.interface';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Environment, environmentToken } from '@environment';
import { PaginationParams } from '@app/driver-metrics/model/driver-metrics-data-source';
import { Pageable } from '@app/shared/models/Pageable.interface';

@Injectable({
  providedIn: 'root'
})
export class AdmResource {
  private readonly baseUrl: string;
  constructor(private httpClient: HttpClient, @Inject(environmentToken) private environment: Environment) {
    this.baseUrl = `${this.environment.apiUrl}${environment.apiPath}`;
  }

  getAdmData(
    payload: InfluxQueryOutline,
    { pageSize, pageNumber }: PaginationParams
  ): Observable<Pageable<MetricsData>> {
    return this.httpClient.post<Pageable<MetricsData>>(`${this.baseUrl}/analytics/${payload.buildingId}/adm`, payload, {
      params: new HttpParams().set('page', pageNumber.toString()).set('size', pageSize.toString())
    });
  }

  downloadExport(payload: InfluxQueryOutline): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/analytics/${payload.buildingId}/adm/export`, payload, {
      responseType: 'blob'
    });
  }

  getDriverStaticData(payload: DriverStaticPayload): Observable<DriverStaticData[]> {
    return this.httpClient.post<DriverStaticData[]>(
      `${this.baseUrl}/building/${payload.buildingId}/driver-static`,
      payload
    );
  }
}
